<template>
  <el-dialog
    title="标签生产"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="开始序号："
        prop="beginTagNo">
        <el-input-number
          v-model="info.beginTagNo"
          :max="99999999"
          :min="1"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="结束序号："
        prop="endTagNo">
        <el-input-number
          v-model="info.endTagNo"
          :max="99999999"
          :min="1"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="生产数量："
        prop="tagCount">
        <el-input-number
          v-model="info.tagCount"
          :max="200000"
          :min="1"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="生产备注："
        prop="remarks">
        <el-input
          v-model="info.remarks"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import AppraiseLable from '../../../../service/appraiseLable'
export default {
  name: 'LabelProductionModal',
  data() {
    return {
      loading: false,
      visible: false,
      info: { tagCount: undefined, beginTagNo: undefined, endTagNo: undefined, remarks: '' },
      rules: {
        tagCount: [{ required: true, message: '请输入标签数量', trigger: 'blur' }],
        beginTagNo: [{ required: true, message: '请输入开始序号', trigger: 'blur' }],
        endTagNo: [{ required: true, message: '请输入结束序号', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleClose() {
      this.info = { ...this.info, ...this.$options.data().info }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { tagCount, beginTagNo, endTagNo } = this.info
          if (endTagNo < beginTagNo) {
            this.$message.error('结束序号不能小于开始序号')
            return
          }
          const tagCount1 = endTagNo - beginTagNo + 1
          if (tagCount > tagCount1) {
            this.$message.error('生产数量不能大于结束序号减去开始序号')
            return
          }
          const title = tagCount < tagCount1 * 0.9 ? `实际生产数量（${tagCount}个）小于标签数量(${tagCount1}个)的90%，是否继续？` : `是否确认生产${tagCount}个标签`
          this.$confirm(title, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
            .then(() => {
              this.addtagsegment()
            })
        }
      })
    },
    addtagsegment() {
      this.loading = true
      AppraiseLable.addtagsegment({ ...this.info })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.$message.success('生产成功')
            this.visible = false
            this.$emit('fetch')
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    init() {
      this.visible = true
    }
  }
}
</script>
